<empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>

<div class="col-content show-display">
  <div class="header-content mb-xl-4 mb-3">
    <div class="heading">Gestión de poseedores</div>
    <div class="actions">
      <button type="button" class="btn btn-outline-primary" (click)="openModalPoseedorNoRegistrado()" *ngIf="canEditSection()">
        Alta nuevo poseedor
      </button>
      <button type="button" class="btn btn-primary" (click)="openModalRelacion()" *ngIf="canEditSection()">
        Añadir residuos del acuerdo con poseedor
      </button>
    </div>
  </div>

  <form class="container-form form-search py-3" [formGroup]="searchForm">
    <div class="row form filters-row">
      <!-- <div style="flex: 1 1 400px; max-width: 420px;">
        <label for="gestorFiltro">Gestor</label>
        <lib-ge-select-pagination
          class="lib-ge-select"
          [endPointFilter]="gestoresEndpoint"
          [localData]="gestoresDelAcuerdo"
          [updateList]="updateList"
          [formControlNameSelect]="getFormControl('gestor')"
          [descripcion]="getGestorDescription"
          [objQueryName]="getGestorObjectQuery"
          [placeHolder]="'-- Gestor del acuerdo --'"
          (selectedModel)="onGestorSelected($event)">
        </lib-ge-select-pagination>

      </div>

      <div style="flex: 1 1 400px; max-width: 420px;">
        <label for="poseedorFiltro">Poseedor</label>
        <lib-ge-select-pagination
          class="lib-ge-select"
          [endPointFilter]="poseedorEndpoint"
          [localData]="poseedoresDelAcuerdo"
          [updateList]="updateList"
          [formControlNameSelect]="getFormControl('poseedor')"
          [descripcion]="getPoseedorDescription"
          [objQueryName]="getObjectQuery"
          [placeHolder]="'-- Poseedor --'"
          (selectedModel)="onPoseedorSelected($event)">
        </lib-ge-select-pagination>
      </div> -->

      <div class="filter-field filter-doc">
        <label for="documentoFiltro">Documento(DNI/NIF/NIE)</label>
        <input type="text" class="form-control" formControlName="documento" id="documentoFiltro" placeholder="-- Documento --">
      </div>

      <div class="filter-field filter-estado">
        <label for="estadoFiltro">Estado</label>
        <mat-form-field class="custom-mat-form-field" appearance="outline">
          <mat-select formControlName="estado" id="estadoFiltro" placeholder="-- Estado --">
            <mat-option *ngFor="let est of estadosPoseedorAcuerdo" [value]="est">
              {{ est.descripcionCorta }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="filter-field filter-ler">
        <label for="codigoLerFiltro">Código LER</label>
        <mat-form-field class="custom-mat-form-field" appearance="outline">
          <mat-select formControlName="codigoLer" id="codigoLerFiltro" placeholder="-- Código LER --">
            <mat-option *ngFor="let ler of codigosLerArray" [value]="ler">
              {{ ler.tipoCodigo }} - {{ ler.descripcion }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- <div style="flex: 1 1 180px; max-width: 180px;">
        <label for="peligrosidadFiltro">Peligrosidad</label>
        <mat-form-field class="custom-mat-form-field" appearance="outline">
          <mat-select formControlName="peligrosidad" id="peligrosidadFiltro" placeholder="-- Peligrosidad --">
            <mat-option [value]="true">Sí</mat-option>
            <mat-option [value]="false">No</mat-option>
          </mat-select>
        </mat-form-field>
      </div> -->
    </div>

    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" (click)="clearSearcher()">Limpiar</button>
      <button type="button" class="btn btn-primary" (click)="searchData()">Buscar</button>
    </div>
  </form>

  <div *ngIf="gridArray.length !== 0 else messageClear" class="datatable-container table-responsive overflow-table table-detail-width-100 mt-3">
    <lib-ge-table [headArray]="headArray" [gridArray]="gridArray" (actionButton)="action($event)"></lib-ge-table>
    <div class="d-flex pb-2 flex-row justify-content-center align-items-center">
      <div class="d-flex mt-2" *ngIf="hasMultiplePages()">
        <ngb-pagination [pageSize]="pageSize" [collectionSize]="recordsTotal" [(page)]="pageNumber"
          (pageChange)="renderPage($event)" [maxSize]="5" aria-label="Default pagination" size="sm">
        </ngb-pagination>
      </div>
      <div class="mt-2 selectPage" *ngIf="hasMultiplePages()">
        <label for="itemsPerPage">Mostrar:</label>
        <select id="itemsPerPage" [(ngModel)]="selectedItemsPerPage" (change)="onItemsPerPageChange()">
          <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
        </select>
      </div>
    </div>
  </div>

  <ng-template #messageClear>
    <div class="container-menu">
      <div class="mensaje-container">
        <p class="mensaje-linea">Sin información registrada</p>
      </div>
    </div>
  </ng-template>
</div>
